import AvisosYBlogTemplate from "../components/templates/AvisosYBlogTemplate";

const AvisosYBlog = () => {
    return (
        <div className="w-full">
            <AvisosYBlogTemplate/> 
        </div>
    )
}; 

export default AvisosYBlog;